import React from 'react';
import ReactDOM from 'react-dom';
import { Analytics } from 'analytics';
import App from './App';
import './styles.css';
import './odbs/odbs.scss';
import { datadogRum } from '@datadog/browser-rum';

declare const window: any;

Analytics.init(window.env.REACT_APP_MIXPANEL_TOKEN);

if (window.env.REACT_APP_DATADOG_RUM_ENABLED) {
  datadogRum.init({
    applicationId: window.env.REACT_APP_DATADOG_RUM_APPLICATION_ID,
    clientToken: window.env.REACT_APP_DATADOG_RUM_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'ondeck_partner_ux',
    env: window.env.REACT_APP_ENV,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackSessionAcrossSubdomains: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'allow',
    allowedTracingUrls: [
      window.env.REACT_APP_PARTNER_ORCHESTRATOR,
      window.env.REACT_APP_PARTNER_PORTAL
    ]
  });
  datadogRum.startSessionReplayRecording();
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
